import { render, staticRenderFns } from "./kpdata.vue?vue&type=template&id=103284f6&scoped=true&"
import script from "./kpdata.vue?vue&type=script&lang=js&"
export * from "./kpdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103284f6",
  null
  
)

export default component.exports